import * as types from "../actions/actionTypes";
import { getAllOrderEstimatesResponse, getOrderEstimateByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const orderestimateEntity = createEntitySagas({
  entity: "orderestimate",
  endpoint: "order-estimates",
  label: "Estimate",
  scope: "none",
  selectSlice: (state) => state.orderestimate,
  listKey: "estimates",
  types: {
    getAll: types.GET_ALL_ORDER_ESTIMATES,
    getById: types.GET_ORDER_ESTIMATE_BY_ID,
    create: types.CREATE_ORDER_ESTIMATE,
    update: types.UPDATE_ORDER_ESTIMATE,
    remove: types.DELETE_ORDER_ESTIMATE,
  },
  actions: { getAllResponse: getAllOrderEstimatesResponse, getByIdResponse: getOrderEstimateByIdResponse },
});

export const orderestimateSaga = orderestimateEntity.watcher;
